var React = require('react');

function IcShareEmail (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M31 16c0-8.284-6.716-15-15-15C7.716 1 1 7.716 1 16c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15zM8 11a1 1 0 011-1h14a1 1 0 011 1v10a1 1 0 01-1 1H9a1 1 0 01-1-1V11zm2 9v-6.826l5.35 4.585a1 1 0 001.3 0L22 13.174V20H10zm6-4.317L11.703 12h8.594L16 15.683z","fill":"currentColor"}));
}

IcShareEmail.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = IcShareEmail;

IcShareEmail.default = IcShareEmail;
